import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Text, Flex, Icon, Button, useScreenResolution, useCheckIfSubscriptionFeatureActiveBroker } from 'dash-ui';
import { DashFeaturesEnum } from 'dash-common';

import { RoutesPath } from 'flow-components/routes/routes';

const Container = styled(Flex)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;

function PortfolioViewsPlaceholder({
  message,
  buttonPlaceholder,
}: {
  message: string;
  buttonPlaceholder?: string;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation(['pages']);
  const theme = useTheme();
  const {
    devices: { isMobile },
  } = useScreenResolution();
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING,
  ]);

  return (
    <Container p={[8, 0, 0, 0]} flex={1} w="100%" h="100%" alignItems="center">
      <Flex
        w="100%"
        flex={1}
        alignItems="center"
        justifyContent={isMobile ? 'flex-start' : 'center'}
      >
        <Icon
          name="presentation"
          size={isMobile ? 50 : 126}
          color={theme.colors.b30}
        />
      </Flex>
      <Flex flex={2} flexDirection="column" justifyContent="center">
        <Flex>
          <Text lg semibold>
            {t(
              'pages:dashboardPage:portfoliosWidget:noPortfoliosPlaceholderTitle'
            )}
          </Text>
        </Flex>
        <Flex mt={0.5}>
          <Text color={theme.colors.n80}>{message}</Text>
        </Flex>
        {buttonPlaceholder && (
          <Flex mt={2}>
            <Button
              onClick={() => {
                if (checkFeatureAccess()) {
                  navigate(RoutesPath.Portfolios);
                }
              }}
              px={8}
              variation="outline"
            >
              {buttonPlaceholder}
            </Button>
          </Flex>
        )}
      </Flex>
    </Container>
  );
}

export default PortfolioViewsPlaceholder;
